import { motion } from 'framer-motion';
import { Star } from 'lucide-react';

const marqueeItems = [
  '★ 5.0 Google Rating',
  '15+ Year Warranty',
  'Premium Dulux Paints',
  '1,500+ Roofs Completed',
  'Free Inspections',
  'Blue Mountains Local',
  '25+ Years Experience',
  'Licensed & Insured',
  '★ 5.0 Google Rating',
  '15+ Year Warranty',
  'Premium Dulux Paints',
  '1,500+ Roofs Completed',
  'Free Inspections',
  'Blue Mountains Local',
  '25+ Years Experience',
  'Licensed & Insured',
];

export default function Marquee() {
  return (
    <div className="py-6 bg-[#111A2E] overflow-hidden border-y border-white/5">
      <motion.div 
        className="flex gap-12 whitespace-nowrap marquee"
        style={{ width: 'max-content' }}
      >
        {marqueeItems.map((item, index) => (
          <div 
            key={index} 
            className="flex items-center gap-3 text-[#94A3B8]"
          >
            <span className="text-sm md:text-base font-medium tracking-wide">
              {item}
            </span>
            <div className="w-1.5 h-1.5 rounded-full bg-[#38BDF8]" />
          </div>
        ))}
      </motion.div>
    </div>
  );
}
